import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['isTmgaz', 'logoImg', 'brandTitle', 'brandCode', 'isLocalhost']),
  },
};
